import { AssessmentGroup } from "app/shared/models/assessment-group";
import { AssessmentTokenService } from "app/shared/services/assessment-token.service";
import { AlertService } from "app/shared/services/alert.service";
import { ClientService } from "app/shared/services/client.service";
import { ManagedClient } from "app/shared/models/managed-client";
import { Assignment } from "app/shared/models/Assignment";
import { Assessment } from "app/shared/models/assessment";
import { AssignedAssessment } from "app/shared/models/AssignedAssessment";
import { Injectable } from "@angular/core";
import { AssignmentService } from "app/shared/services/assignment.service";
import { AssignedAssessmentGroup } from "app/shared/models/AssignedAssessmentGroup";
import { AssignmentSingle } from "app/shared/models/AssignmentSingle";

/**
 * The responsibility of this class is to take assessment batteries &
 * individual assessments and assign them to clients.
 */
@Injectable()
export class AssessmentAssignerService {

    constructor(private assessmentTokenService:AssessmentTokenService
      , private alertService:AlertService, private clientService:ClientService
      , private assignmentService:AssignmentService)
    {

    } 
    public addAssessmentsFromBattery(client:ManagedClient, group:AssessmentGroup) {
        if (!group) {
          console.error("group was null.  Cannot add");
          this.alertService.error("There was an error in adding this item to the client.  Please try again or contact customer support");
          return;
        }

        // add each of the group assignments.
        // TODO: should we do a promise.All here?? so we can trigger a message
        // when all of the assessments have been added?
        if (this.assessmentTokenService.isTokensEnabled() 
            && this.assessmentTokenService.getGroupRemainingTokens(group) <= 0) {
          this.alertService.error("You have no available tokens for this battery. Purchase more to assign this battery");
          return;
        }
        let date = new Date();
        let alertId = this.alertService.info("Adding " + group.Name + " to " + client.id, 120000);
        this.assignmentService.createClientGroupAssignment(client, group)
        .then((assignment:Assignment) => {
          this.consumeTokens(assignment);
          client.assignments.push(assignment);
          this.clientService.syncLocalClient(client);
          this.clearAlert(alertId, 750);
          this.alertService.success("Added " + assignment.Name + " to " + client.id);
        })
        .catch((error) => {
            console.error(error);
          this.clearAlert(alertId);
          this.alertService.error("There was an error in adding this item to the client.  Please try again or contact customer support");
        });
    }
    
    public addAssessment(client:ManagedClient, assessment: Assessment) {
        console.log("adding ", assessment);
        if (!assessment) {
          console.error("assessment was null.  Cannot add");
          return;
        }
    
        if (this.assessmentTokenService.isTokensEnabled() 
            && !this.assessmentTokenService.hasTokens(assessment)) {
          this.alertService.error( "You have no available tokens for this assessment.  Purchase more to assign this test", 3000);
          return;
        }
        // TODO: stephen this needs to be switched to be the
        // assessments.
        let assignment = new AssignmentSingle();
        assignment.Type = "Assessment";
        assignment.DateAssigned = new Date();
        let assignmentItem = new AssignedAssessment();
        assignmentItem.Name = assessment.name;
        assignmentItem.Type = "Assessment";
        assignmentItem.Uid = assessment.uid;
        assignment.Items.push(assignmentItem);

        let alertId = this.alertService.info("Adding " + assessment.name + " to " + client.id, 120000);
        this.assignmentService.saveClientAssignment(client, assignment)
          .then((assignment:Assignment) => {
            this.consumeTokens(assignment);
            client.assignments.push(assignment);
            this.clientService.syncLocalClient(client);
            this.clearAlert(alertId, 750);
            this.alertService.success("Added " + assessment.name + " to " + client.id);
          })
          .catch((error) => {
            this.clearAlert(alertId);
            this.alertService.error("There was an error in adding this item to the client.  Please try again or contact customer support");
            console.error(error);
          });
    }

    public removeAssessment(client:ManagedClient, assignment:Assignment) {
      
      this.assignmentService.removeClientAssignment(client, assignment).then(() => {
        this.freeTokens(assignment);
        client.removeAssignment(assignment);
        this.clientService.syncLocalClient(client);
        this.alertService.success("Assignment removed");
      })
      .catch((error) => {
        console.error(error);
        this.alertService.error("Failed to remove assignment", 1500);
      });
    }

    private consumeTokens(assignment:Assignment) {
      let method = this.assessmentTokenService.consumeToken.bind(this.assessmentTokenService);
      return this.applyAssignmentMethod(assignment, method);
    }

    private freeTokens(assignment:Assignment) {
      let method = this.assessmentTokenService.freeToken.bind(this.assessmentTokenService);
      return this.applyAssignmentMethod(assignment, method);
    }
    private applyAssignmentMethod(assignment:Assignment, method:(uid:string) => void) {
      if (this.assessmentTokenService.isTokensEnabled()) {
        if (assignment.Type == "Assessment" && assignment.Items.length) {
          let item = assignment.Items[0] as AssignedAssessment;
          method(item.Uid);
        } else if (assignment.Type == "AssessmentGroup") {
          let item = assignment as AssignedAssessmentGroup;
          item.getAssessmentItems().map(i => method(i.Uid));
        }
      }
    }

    private clearAlert(alertId, timeout?:number) {
    timeout = timeout || 0;

    // we set a slight delay so people can see we were adding the assessment.
    setTimeout(() => {
        this.alertService.clearAlert(alertId);
    }, timeout);
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/services/assessment-assigner.service.ts